// constants
import { showSuccessAlert } from "../../constants/alerts";
import { CongratsBoxActionTypes } from "./constants";

const INIT_STATE = {
  congratsData: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface CongratsBoxData {
  id: number;
  heading: string,
  heading_ar: string,
  sub_text : string,
  sub_text_ar : string,
  file: any;
}

interface NewsBannerActionType {
  type:
    | CongratsBoxActionTypes.API_RESPONSE_SUCCESS
    | CongratsBoxActionTypes.API_RESPONSE_ERROR
    | CongratsBoxActionTypes.CREATE_CONGRATS
    | CongratsBoxActionTypes.GET_CONGRATS
    | CongratsBoxActionTypes.UPDATE_CONGRATS
    | CongratsBoxActionTypes.DELETE_CONGRATS;
  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    newsBanner?: [];
  };
}



const CongratsBox = (
  state: any = INIT_STATE,
  action: NewsBannerActionType
): any => {
  switch (action.type) {
    case CongratsBoxActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CongratsBoxActionTypes.CREATE_CONGRATS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CongratsBoxActionTypes.GET_CONGRATS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            congratsData: action.payload.data,
          };
        }
        case CongratsBoxActionTypes.UPDATE_CONGRATS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CongratsBoxActionTypes.DELETE_CONGRATS: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case CongratsBoxActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CongratsBoxActionTypes.CREATE_CONGRATS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CongratsBoxActionTypes.UPDATE_CONGRATS: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case CongratsBoxActionTypes.GET_CONGRATS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CongratsBoxActionTypes.DELETE_CONGRATS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case CongratsBoxActionTypes.CREATE_CONGRATS:
      return { ...state, loading: true };
    case CongratsBoxActionTypes.UPDATE_CONGRATS:
      return { ...state, loading: true };
    case CongratsBoxActionTypes.GET_CONGRATS:
      return { ...state, loading: true, initialLoading: true };
    case CongratsBoxActionTypes.DELETE_CONGRATS:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default CongratsBox;
